var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Api from "../api/api";
var http = new Api();
function newNav(params, index, sta) {
    return {
        name: params,
        path: navPathList[index],
        disable: index === 0 || !sta ? 1 : 0,
    };
}
var navList = ["基本信息", "案例背景", "地图系统", "措施系统", "指标系统", "变量公式", "事件系统", "评估系统"];
var navPathList = ["/case", "/case/backgroundInfo", "/case/mapSystem", "/case/measureSystem", "/case/targetSystem", "/case/formula", "/case/eventSystem", "/case/evaluateSystem"];
export default {
    state: {
        /** 导航栏状态
         * disable
         * @param 0->不可编辑该页面
         * @param 1->可编辑该页面
         * @param 2->已完成该页面
         */
        caseNav: navList.map(function (item, index) {
            return newNav(item, index);
        }),
        /**
         * 案例场景设置
         */
        prefecture: {
            id: "",
            intelligentExpId: "",
            mapDepartmentList: [],
            path: "",
            userId: "",
        },
        // 措施类别
        measuretypeList: [
            {
                typeName: "",
                intelligentExpId: "",
                id: ""
            }
        ],
        // 执行指标
        executeTargetList: [],
        // 核心指标
        kernelIndexList: [],
    },
    mutations: {
        /** 禁用基本信息之后的tab */
        pulNavListDisableState: function (state) {
            state.caseNav = navList.map(function (item, index) {
                return newNav(item, index, true);
            });
        },
        /** 解锁基本信息只有的tab */
        pulNavListState: function (state) {
            state.caseNav = navList.map(function (item, index) {
                return newNav(item, index);
            });
        },
        /**
         * 获取场景部门数据
         */
        initMapSystem: function (state, value) {
            state.prefecture = value;
        },
        /**
         * 设置措施类型
         */
        initMeasureType: function (state, value) {
            state.measuretypeList = value;
        },
        /**
         * 设置执行指标
         */
        initExecuteTarget: function (state, value) {
            state.executeTargetList = value;
        },
        /**
       * 设置核心指标
       */
        initkerneTarget: function (state, value) {
            state.kernelIndexList = value;
        },
        /**
         * 设置部门措施
         * @param state 元数据
         * @param value 设置的措施设置
         * @param id 要设置的部门
         */
        setMeasures: function (state, payloadvalue) {
            var DepartmentData = state.prefecture.mapDepartmentList.find(function (value) {
                return value.id === payloadvalue.id;
            });
            console.log(payloadvalue, DepartmentData, "id");
            if (!DepartmentData) {
                return "暂无该部门";
            }
            // 因为是批量多条措施所以直接替换掉
            DepartmentData.MeasuresList = payloadvalue.newValue;
            // let newMeasuresData = DepartmentData.MeasuresList?.find(value => {
            //   value.id === payloadvalue.newValue.id
            // })
            // // 如果该部门下没有有此条措施信息 则创建 否则 修改
            // if (!newMeasuresData) {
            //   DepartmentData.MeasuresList?.push(payloadvalue.newValue)
            // } else {
            //   newMeasuresData = payloadvalue.newValue
            // }
        }
    },
    getters: {
        /**
         * 返回所有部门
         */
        DepartmentList: function (state) {
            return state.prefecture.mapDepartmentList;
        },
        /**
         * 幸福满意度id
         */
        satisfactionId: function (state) {
            return state.kernelIndexList.find(function (item) {
                return item.name == "目标人群满意度";
            }).id;
        },
        /**
         * 财政资源id
         */
        financialId: function (state) {
            return state.kernelIndexList.find(function (item) {
                return item.name == "财政资源";
            }).id;
        }
    },
    actions: {
        /**
         *  查询id查询场景和部门
         * @param id string
         */
        queryMapSystem: function (_a, id) {
            var commit = _a.commit, dispatch = _a.dispatch;
            return new Promise(function (resolve, reject) {
                http.queryMapSystem({
                    intelligentExpId: id
                }).then(function (res) {
                    if (res.data.data) {
                        commit("initMapSystem", res.data.data);
                        dispatch("batchQueryMeasureSet", id).then(function () {
                            resolve(res.data.data);
                        });
                    }
                    else {
                        reject("暂无数据");
                    }
                }).catch(function (err) {
                    reject(err);
                });
            });
        },
        /**
         *  查询id部门和措施
         * @param id string
         */
        batchQueryMeasureSet: function (_a, id) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                http.batchQueryMeasureSet({
                    intelligentExpId: id
                }).then(function (res) {
                    if (res.data.data) {
                        res.data.data.forEach(function (item) {
                            commit("setMeasures", {
                                newValue: item.measureSetBeanList,
                                id: item.mapDepartmentId
                            });
                        });
                        resolve(res.data.data);
                    }
                    else {
                        reject("暂无数据");
                    }
                }).catch(function (err) {
                    reject(err);
                });
            });
        },
        /**
         *  查询id查询措施类别
         * @param id string
         */
        queryMeasureType: function (_a, id) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                http.queryMeasureType({
                    intelligentExpId: id
                })
                    .then(function (res) {
                    if (res.data.data) {
                        commit("initMeasureType", res.data.data);
                        resolve(res.data.data);
                    }
                    else {
                        reject("暂无数据");
                    }
                })
                    .catch(function (err) {
                    reject(err);
                });
            });
        },
        /**
         *  查询id查询执行指标
         * @param id intelligentExpId
         */
        queryExecuteIndex: function (_a, id) {
            var _this = this;
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                http
                    .queryExecuteIndex({ intelligentExpId: id })
                    .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        if (res.data.data) {
                            commit("initExecuteTarget", res.data.data);
                        }
                        resolve();
                        return [2 /*return*/];
                    });
                }); })
                    .catch(function (err) {
                    reject(err);
                });
            });
        },
        /**
         *  查询id查询核心指标
         * @param id intelligentExpId
         */
        queryKernelIndex: function (_a, id) {
            var _this = this;
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                http
                    .queryKernelIndex({ intelligentExpId: id })
                    .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        if (res.data.data) {
                            commit("initkerneTarget", res.data.data);
                        }
                        resolve();
                        return [2 /*return*/];
                    });
                }); })
                    .catch(function (err) {
                    reject(err);
                });
            });
        },
    }
};
